/* eslint-disable no-param-reassign */
const FormToJSON = {
	// Checks that an element has a non-empty `name` and `value` property.
	isValidElement(element) {
		return element.name && element.value;
	},

	// Checks if an element’s value can be saved (e.g. not an unselected checkbox).
	isValidValue(element) {
		return !['checkbox', 'radio'].includes(element.type) || element.checked;
	},

	// Checks if an input is a checkbox, because checkboxes allow multiple values.
	isCheckbox(element) {
		return element.type === 'checkbox';
	},

	isFileInput(element) {
		return element.type === 'file';
	},

	// Checks if an input is a `select` with the `multiple` attribute.
	isMultiSelect(element) {
		return element.options && element.multiple;
	},

	// Retrieves the selected options from a multi-select as an array.
	getSelectValues(options) {
		[].reduce.call(
			options,
			(values, option) => {
				return option.selected ? values.concat(option.value) : values;
			},
			[]
		);
	},

	// Retrieves input data from a form and returns it as a JSON object.
	// param  {HTMLFormControlsCollection} elements  the form elements
	// return {Object} form data as an object literal
	formToJSON(elements) {
		return [].reduce.call(
			elements,
			(data, element) => {
				// Make sure the element has the required properties and should be added.
				if (FormToJSON.isValidElement(element) && FormToJSON.isValidValue(element)) {
					// Some fields allow for more than one value, so we need to check if this
					// is one of those fields and, if so, store the values as an array.
					if (FormToJSON.isCheckbox(element)) {
						data[element.name] = (data[element.name] || []).concat(element.value);
					} else if (FormToJSON.isMultiSelect(element)) {
						data[element.name] = FormToJSON.getSelectValues(element);
					} else if (FormToJSON.isFileInput(element)) {
						// do nothing
					} else {
						data[element.name] = element.value;
					}
				}
				return data;
			},
			{}
		);
	},
};

export default FormToJSON.formToJSON;
